<form #noteForm="ngForm" (ngSubmit)="onSubmit(noteForm)" class="md-form mt-0 mb-0">
  <div class="d-sm-flex" style="justify-content: space-between">
    <div class="form-outline">
      <textarea
        type="text"
        id="notes"
        class="md-textarea form-control pt-0 pb-0"
        name="notes"
        placeholder="Add a note"
        #noteModel="ngModel"
        [(ngModel)]="noteText"
        mdbInput
        mdbValidate
        required
      ></textarea>
      <mdb-error id="noteError" *ngIf="noteModel.invalid && (noteModel.dirty || noteModel.touched)">You can't save an empty note</mdb-error>
    </div>
    <app-loading [busy]="noteSaving"></app-loading>
    <ng-container *ngIf="!noteSaving">
      <button type="submit" mdbBtn color="trakly-action" class="relative waves-light btn-sm btn">Save</button>
    </ng-container>
  </div>
</form>

<div class="mt-2 p-0">
  <ng-container *ngIf="noNotes">
    <h6 class="card-title">There are no notes for this client yet</h6>
  </ng-container>

  <app-loading [busy]="loadingNotes"></app-loading>

  <ng-container *ngIf="!noNotes">
    <table class="table table-sm" mdbTable hover="true">
      <thead>
        <tr>
          <th>
            <span class="md-form col-6">
              <input
                [(ngModel)]="searchText"
                mdbInput
                name="noteSearchText"
                type="search"
                id="noteSearchText"
                placeholder="Search"
                style="font-size: small; border-bottom-color: #7b7f82"
              />
            </span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let note of clientNotes | filterNote: searchText">
          <tr
            [ngClass]="{
              'update-success': note.recentlyUpdated,
              'note-milestone': note.noteTypeDescription == 'Milestone',
              'note-admin': note.noteTypeDescription == 'Admin'
            }"
          >
            <td class="text-muted small" style="min-width: 115px">
              <span>{{ note.dateTimeCreated | date: "dd MMM yyyy HH:mm" }} | {{ note.createdByUserFullName }}</span>
            </td>
            <td class="text-muted small">
              <mdb-icon *ngIf="note.noteTypeDescription == 'Milestone'" fas icon="crown" class="mr-1"></mdb-icon>
              <mdb-icon *ngIf="note.noteTypeDescription == 'Admin'" fas icon="user-edit" class="mr-1"></mdb-icon>
              {{ note.note }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>
</div>
